import { Button, Stack, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface ActionButtonProps {
  text: string;
  icon: ReactElement;
  onClick: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  disabled?: boolean;
}

export const ActionButton = ({ icon, text, onClick, disabled = false }: ActionButtonProps) => {
  return (
    <Button
      variant='ghost'
      borderRadius='md'
      _hover={{ bg: 'hover.gray' }}
      justifyContent='flex-start'
      px={1}
      py={8}
      border='1px solid'
      borderColor='divider.gray'
      overflow='hidden'
      onClick={onClick}
      disabled={disabled}
      minW='94px'
    >
      <Stack direction='column' alignItems='center' padding={2} w='full'>
        {icon}
        <Text fontWeight='medium' fontSize='xs'>
          {text}
        </Text>
      </Stack>
    </Button>
  );
};
